import { io, Socket } from 'socket.io-client';

type EventCallback = (...args: any[]) => void;

class SocketPlugin {
  private socket: Socket | null = null;
  private url: string;

  constructor(url: string) {
    this.url = url;
  }

  connect(): void {
    if (!this.socket) {
      this.socket = io(this.url, {
        query: {'token': process.env.REACT_APP_SOCKET_AUTH_TOKEN},
        transports: ['websocket'],
        reconnectionDelay: 500000
      });
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event: string, callback: EventCallback): void {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  emit(event: string, ...args: any[]): void {
    if (this.socket) {
      this.socket.emit(event, ...args);
    }
  }

  off(event: string): void {
    if (this.socket) {
      this.socket.off(event);
    }
  }
}

const socketPlugin = new SocketPlugin(process.env.REACT_APP_SOCKET_SERVER_URL!);

export default socketPlugin;
